import { useCallback } from 'react'
import { useMutation } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'

/**
 * Returns the `onSaveCode` handler for `LoungeCodeCard`: saves a custom join code for the lounge.
 * Errors propagate so the card can show "already in use" / invalid states.
 */
export function useSaveLoungeJoinCode(
  loungeId: Id<'lounges'> | undefined,
  userId: string,
  onSaved?: (joinCode: string) => void
) {
  const setJoinCode = useMutation(api.lounges.mutations.setLoungeJoinCode)

  return useCallback(
    async (joinCode: string) => {
      if (!loungeId) return
      const result = await setJoinCode({ loungeId, actorId: userId, joinCode })
      onSaved?.(result.joinCode)
    },
    [loungeId, userId, setJoinCode, onSaved]
  )
}
